import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "payments-upload" }
const _hoisted_2 = { class: "row justify-content-center" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "payments-upload__head" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "payments-upload__head__title" }, " Carga masiva de pagos mensuales ")
], -1)
const _hoisted_5 = { class: "payments-upload__body" }
const _hoisted_6 = { action: "" }
const _hoisted_7 = { class: "row mb-4" }
const _hoisted_8 = { class: "col-md-7" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "Cargar Excel de pagos", -1)
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-md-10" }
const _hoisted_13 = { class: "payments-upload__body__loader" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-circle-notch fa-spin d-block mb-1" }, null, -1)
const _hoisted_16 = { key: 1 }
const _hoisted_17 = {
  key: 0,
  class: "table table-hover table-striped"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "N"),
    /*#__PURE__*/_createElementVNode("th", null, "Póliza"),
    /*#__PURE__*/_createElementVNode("th", null, "Cliente"),
    /*#__PURE__*/_createElementVNode("th", null, "Fecha de pago"),
    /*#__PURE__*/_createElementVNode("th", null, "Monto de pago"),
    /*#__PURE__*/_createElementVNode("th", null, "Id de pago")
  ])
], -1)
const _hoisted_19 = {
  key: 1,
  class: "form-group text-right mt-5"
}
const _hoisted_20 = ["disabled"]
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { class: "modal-error__head" }
const _hoisted_24 = ["src"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("h3", null, "Ups!", -1)
const _hoisted_26 = { class: "modal-error__head" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "modal-success__head pt-2" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check-circle fa-3x" }),
  /*#__PURE__*/_createElementVNode("h3", null, "Registro de pagos exitoso")
], -1)
const _hoisted_28 = { class: "modal-success__head" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("p", null, " Se han registrado los pagos del mes de las pólizas cargadas. ", -1)
const _hoisted_30 = { class: "text-center mt-3" }
const _hoisted_31 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_modal = _resolveComponent("b-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("form", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("input", {
                      class: "form-control",
                      type: "file",
                      onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.uploadFile($event)))
                    }, null, 32)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    (this.flags.searching)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          _hoisted_15,
                          _createTextVNode(" Cargando operaciones... ")
                        ]))
                      : _createCommentVNode("", true),
                    (this.flags.noPendingPayments)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, " No se encontraron pagos pendientes para las pólizas cargadas. "))
                      : _createCommentVNode("", true)
                  ]),
                  (!_ctx.flags.searching && _ctx.operations.length > 0)
                    ? (_openBlock(), _createElementBlock("table", _hoisted_17, [
                        _hoisted_18,
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.operations, (item, index) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: item.additionalContributionId
                            }, [
                              _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                              _createElementVNode("td", null, _toDisplayString(item.referencePolicyNumber), 1),
                              _createElementVNode("td", null, _toDisplayString(item.user.firstName) + " " + _toDisplayString(item.user.lastName) + " " + _toDisplayString(item.user.secondLastName), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(item.payments[0].transactionDate)), 1),
                              _createElementVNode("td", null, "S/" + _toDisplayString(item.payments[0].amount), 1),
                              _createElementVNode("td", null, _toDisplayString(item.payments[0].transactionExternalId), 1)
                            ]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.operations.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-main",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.registerPayments())),
                          disabled: _ctx.flags.loading
                        }, [
                          (!_ctx.flags.loading)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_21, "Registrar pagos"))
                            : _createCommentVNode("", true),
                          (_ctx.flags.loading)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_22, "Registrando pagos ..."))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_20)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_b_modal, {
      id: "modal-error",
      "ok-only": "",
      "ok-title": "Entiendo",
      centered: "",
      size: "sm",
      "modal-class": "modal-error",
      ref: "modal-error"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("img", {
            src: require('@/assets/images/app/alert.svg'),
            alt: ""
          }, null, 8, _hoisted_24),
          _hoisted_25
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("p", null, _toDisplayString(_ctx.errors.message), 1)
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_b_modal, {
      id: "modal-success",
      "ok-only": "",
      "ok-title": "Entiendo",
      centered: "",
      size: "sm",
      "modal-class": "modal-success",
      ref: "modal-success"
    }, {
      default: _withCtx(() => [
        _hoisted_27,
        _createElementVNode("div", _hoisted_28, [
          _hoisted_29,
          _createElementVNode("p", _hoisted_30, [
            _createElementVNode("a", {
              href: _ctx.basePath + '/operations'
            }, "Ir a mis operaciones", 8, _hoisted_31)
          ])
        ])
      ]),
      _: 1
    }, 512)
  ]))
}